import * as React from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { IInfiniteScrollProps } from 'models/infinitescroll';
require('./style.scss');

interface IProps extends IInfiniteScrollProps {}

class InfiniteScrollIntersection extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.state = {
			isIntersectionInfiniteLoaderInView: false,
		};

		this.intersectionInfiniteScrollRef = React.createRef();
	}

	intersectionInfiniteScrollRef: React.RefObject<HTMLDivElement>;
	intersectionObserver?: IntersectionObserver;

	componentDidMount(): void {
		this.intersectionObserver = new IntersectionObserver((entries) => {
			if (entries[0].intersectionRatio > 0) {
				this.props.hasMore && this.props.next?.();
			}
		});
		// start observing
		this.intersectionObserver.observe(this.intersectionInfiniteScrollRef.current);
	}

	componentWillUnmount(): void {
		if (this.intersectionInfiniteScrollRef.current) {
			this.intersectionObserver?.unobserve(this.intersectionInfiniteScrollRef.current);
			this.intersectionObserver?.disconnect();
		}
	}

	componentDidUpdate(prevProps: Readonly<IProps>): void {
		if (prevProps?.dataLength != this.props.dataLength) {
			this.intersectionObserver?.unobserve(this.intersectionInfiniteScrollRef.current);
			this.intersectionObserver.observe(this.intersectionInfiniteScrollRef.current);
		}
	}

	render(): React.ReactNode {
		return (
			<div className="wrapperCustomInfinityComponent intersection-infinity-scroll">
				{this.props.children}
				<div className="intersection-infinity-scroll__footer">
					{/* this element is a bit higher than the loading element, so next triggers a bit sooner */}
					<div
						className="intersection-infinity-scroll__footer__virtual-before"
						ref={this.intersectionInfiniteScrollRef}
					></div>
					{this.props.hasMore && this.props.loader}
				</div>
			</div>
		);
	}
}

export { InfiniteScrollIntersection };
